import { useSnackbar } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { l } from "@shared/locales/i18n";

interface CopyToClipboardParams {
  successMessage?: string;
  errorMessage?: string;
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

const useCopyToClipboard = () => {
  const { t } = useTranslation();
  const { successSnackbar, criticalSnackbar } = useSnackbar();

  const copyToClipboard = async (
    content: string,
    { successMessage, errorMessage, onSuccess, onError }: CopyToClipboardParams = {}
  ) => {
    try {
      await navigator.clipboard.writeText(content);

      if (onSuccess) {
        onSuccess();
      } else {
        successSnackbar(successMessage ?? t(l.sharedCommon.CopiedToClipboard));
      }
    } catch (error) {
      if (onError) {
        onError(error);
      } else {
        criticalSnackbar(errorMessage ?? t(l.sharedCommon.FailedToCopyText));
      }
    }
  };

  return copyToClipboard;
};

export { useCopyToClipboard };
